import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import FallbackErrorMessage from '../../../../utils/errors/FallbackMessage'
import { EInvoiceOverview } from '../components'

export const EInvoiceOverviewPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <EInvoiceOverview />
    </ErrorBoundary>
  )
}
